import axios from "axios";
import { HOST } from "config/config";
import tableDataQueryStringBuilder from "utils/tableData";

export function getProviders(tableDataParam, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().providersReducer.updating || forceRefresh) {
      if (tableDataParam === undefined) {
        return dispatch({
          type: "GET_PROVIDERS_PENDING",
          payload: axios
            .get(`${HOST}/api/providers`)
            .then(response => response.data)
            .then(json =>
              dispatch({
                type: "GET_PROVIDERS_FULFILLED",
                payload: {
                  items: json
                }
              })
            )
            .catch(error =>
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.message
                }
              })
            )
        });
      }

      return dispatch({
        type: "GET_PROVIDERS_PENDING",
        payload: axios
          .get(`${HOST}/api/providers`, {
            paramsSerializer: params => tableDataQueryStringBuilder(params),
            params: tableDataParam
          })
          .then(response => response.data)
          .then(json => {
            if (tableDataParam) {
              dispatch({
                type: "UPDATE_PROVIDERS_TABLEDATAPARAM",
                payload: tableDataParam
              });
            }

            dispatch({
              type: "GET_PROVIDERS_FULFILLED",
              payload: json
            });
          })
          .catch(error =>
            dispatch({
              type: "GET_PROVIDERS_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function getProvidersForSelect() {
  return (dispatch, getState) => {
    if (!getState().providersReducer.updating) {
      return dispatch({
        type: "GET_PROVIDERS_PENDING",
        payload: axios
          .get(`${HOST}/api/filters/providers`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_PROVIDERS_SELECT_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "SHOW_MESSAGE",
              payload: {
                type: "error",
                titleKey: "error",
                message: error.message
              }
            })
          )
      });
    }
  };
}

export function getProvider(providerId, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().providersReducer.updating || forceRefresh) {
      if (providerId === 0) {
        return dispatch({
          type: "GET_PROVIDER_FULFILLED",
          payload: {
            id: 0,
            internalName: "",
            nameFrench: "",
            nameEnglish: "",
            createdDate: new Date()
          }
        });
      }
      return dispatch({
        type: "GET_PROVIDER_PENDING",
        payload: axios
          .get(`${HOST}/api/providers/${providerId}`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_PROVIDER_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "GET_PROVIDER_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function updateProvider(provider) {
  return dispatch =>
    dispatch({
      type: "UPDATE_PROVIDER",
      payload: provider
    });
}

export function persistProvider(provider) {
  return (dispatch, getState) => {
    if (!getState().providersReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: "PERSISTING_PROVIDER",
          payload: (provider.id === 0
            ? axios.post(`${HOST}/api/providers`, provider)
            : axios.put(`${HOST}/api/providers/${provider.id}`, provider)
          )
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: "PERSISTED_PROVIDER",
                payload: {
                  provider: json,
                  isNew: provider.id === 0
                }
              });

              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "success",
                  titleKey: "success",
                  messageKey: "saved_successful"
                }
              });
              return resolve();
            })
            .catch(error => {
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.response
                }
              });
              return reject();
            })
        })
      );
    }
  };
}
